"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const URLs_1 = require("../utility/URLs");
const react_router_dom_1 = require("react-router-dom");
const Filters_1 = require("../components/Filters");
const helpers_1 = require("../../commonFiles/helpers");
const react_router_dom_2 = require("react-router-dom");
const Paginator_1 = __importDefault(require("../../commonFiles/Paginator"));
function BooksIndex(props) {
    var _a;
    const history = (0, react_router_dom_2.useHistory)();
    const [booksPagination, setbooksPagination] = react_1.default.useState();
    function fetch(params) {
        return URLs_1.Api.fetchBooks(Object.assign(Object.assign(Object.assign({}, (0, Filters_1.getPaginationParams)(booksPagination)), { page_size: 10 }), params));
    }
    return react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'd-flex align-items-center fs-4 ' },
            react_1.default.createElement("i", { className: "bi bi-book" }),
            react_1.default.createElement("div", { className: 'mx-2' }, "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0643\u062A\u0628")),
        react_1.default.createElement("div", { className: 'bg-white rounded shadow m-3 p-4' },
            react_1.default.createElement("div", { className: "col-4" },
                react_1.default.createElement(Filters_1.TextFilter, { apiCall: (newparams) => fetch(newparams), property: 'title', label: 'عنوان الكتاب', useState: [booksPagination, setbooksPagination] })),
            react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, "#"),
                        react_1.default.createElement("th", null, "\u0627\u0644\u0639\u0646\u0648\u0627\u0646"),
                        react_1.default.createElement("th", null, "\u0648\u0635\u0641"),
                        react_1.default.createElement("th", null, "\u0645\u0641\u0639\u0651\u0644"))),
                react_1.default.createElement("tbody", null, (_a = booksPagination === null || booksPagination === void 0 ? void 0 : booksPagination.data) === null || _a === void 0 ? void 0 : _a.map((book, index) => (react_1.default.createElement("tr", { key: index },
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.bookShow(book.id) }, book.id)),
                    react_1.default.createElement("td", null, book.title),
                    react_1.default.createElement("td", null, (0, helpers_1.truncate)(book.description, 200)),
                    react_1.default.createElement("td", null, book.activated ? 'مفعل' : 'غير مفعل')))))),
            react_1.default.createElement(Paginator_1.default, { log: 'FETCH books', apiCall: fetch, useState: [booksPagination, setbooksPagination] })));
}
exports.default = BooksIndex;
